import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

import { currencySymbolForPDF } from '../../../services/orderService';
import { formatMoney } from '../../../util/numberUtils';

import orderStyles from './OrderStyles';

const styles = StyleSheet.create({
  container: {
    marginTop: 40
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 24,
    fontSize: 12
  },
  label: {
    color: '#000',
    fontSize: 11,
    fontWeight: 'bold',
  },
  description: {
    width: '75%',
    textAlign: 'right',
    fontSize: 11
  },
  total: {
    width: '25%',
    textAlign: 'right',
    fontSize: 10
  },
});

const InvoiceTableFooter = ({ invoice, retailerInfo }) => {
  const symbol = currencySymbolForPDF(invoice);
  const currency = invoice.currency || retailerInfo.currency_code;
  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <Text style={styles.description}>Subtotal</Text>
        <Text style={styles.total}>{symbol}{formatMoney(invoice.subtotal)}</Text>
        <Text style={orderStyles.currency}> {currency}</Text>
      </View>
      <View style={styles.row}>
        <Text style={styles.description}>Descuento</Text>
        <Text style={styles.total}>
          {Number(invoice.total_discount) > 0 ? '-' : ''}
          {symbol}
          {formatMoney(invoice.total_discount || 0)}
        </Text>
        <Text style={orderStyles.currency}> {currency}</Text>
      </View>
      <View style={styles.row}>
        <Text style={styles.description}>Subtotal con descuento</Text>
        <Text style={styles.total}>
          {symbol}
          {formatMoney(invoice.subtotal_with_discount || 0)}
        </Text>
        <Text style={orderStyles.currency}> {currency}</Text>
      </View>
      <View style={styles.row}>
        <Text style={styles.description}>Impuesto</Text>
        <Text style={styles.total}>{symbol}{formatMoney(invoice.tax)}</Text>
        <Text style={orderStyles.currency}> {currency}</Text>
      </View>
      <View style={styles.row}>
        <Text style={styles.description}>Valor de envío</Text>
        <Text style={styles.total}>{symbol}{formatMoney(invoice.shipping_value)}</Text>
        <Text style={orderStyles.currency}> {currency}</Text>
      </View>
      <View style={styles.row}>
        <Text style={[styles.description, styles.label]}>Total</Text>
        <Text style={[styles.total, styles.label]}>{symbol}{formatMoney(invoice.total)}</Text>
        <Text style={orderStyles.currency}> {currency}</Text>
      </View>
    </View>
  )
};

export default InvoiceTableFooter